/**
 * Breadcrumbs enhancement (fix)
 * Rebuilds PDP breadcrumbs from sessionStorage (saved via BreadcrumbTracker in header).
 * Loaded after theme.scripts.js to override the bundled enhancer when needed.
 */
(function () {
  var STORAGE_KEY = 'breadcrumb_navigation_path';

  function normalizePath(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return String(url).split('?')[0].split('#')[0];
    }
  }

  function capitalizeTitle(text) {
    if (!text) return '';
    var lower = text.toLowerCase();
    return lower.replace(/^\w/, function (c) {
      return c.toUpperCase();
    });
  }

  function isShopAllCrumb(crumb, shopAllUrl) {
    if (!crumb) return false;
    var title = (crumb.title || '').toLowerCase().trim();
    if (title === 'shop all' || title === 'shop') return true;
    if (shopAllUrl && crumb.url && normalizePath(crumb.url) === normalizePath(shopAllUrl)) {
      return true;
    }
    var path = normalizePath(crumb.url);
    return path === '/collections/shop-all' || path === '/collections/all';
  }

  function getCurrentProductInfo(breadcrumbsNav) {
    var currentPath = normalizePath(window.location.pathname);
    var productTitle = 'Product';
    var productUrl = window.location.pathname;

    var existingProductLink = breadcrumbsNav.querySelector('.breadcrumbs__link--current');
    if (existingProductLink) {
      productTitle = existingProductLink.textContent.trim();
      productUrl = existingProductLink.getAttribute('href') || productUrl;
    } else {
      var pageTitle = document.querySelector('.product-detail h1, main h1, h1');
      if (pageTitle) {
        productTitle = pageTitle.textContent.trim();
      }
    }

    return {
      title: productTitle,
      url: productUrl,
      path: currentPath,
    };
  }

  function enhanceBreadcrumbs() {
    if (!window.location.pathname.includes('/products/')) return;

    var breadcrumbsNav = document.querySelector('.breadcrumbs');
    if (!breadcrumbsNav) return;

    var savedBreadcrumb = null;
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) savedBreadcrumb = JSON.parse(saved);
    } catch (e) {
      return;
    }

    if (!savedBreadcrumb || !savedBreadcrumb.path || savedBreadcrumb.path.length === 0) {
      return;
    }

    var breadcrumbsList = breadcrumbsNav.querySelector('.breadcrumbs__list');
    if (!breadcrumbsList) return;

    var productInfo = getCurrentProductInfo(breadcrumbsNav);
    var lastPathItem = savedBreadcrumb.path[savedBreadcrumb.path.length - 1];
    var lastPathUrl = lastPathItem ? normalizePath(lastPathItem.url) : '';
    var isLastItemCurrentPage = Boolean(lastPathItem && lastPathUrl === productInfo.path);

    var shopAllUrl = (savedBreadcrumb.path[0] && savedBreadcrumb.path[0].url) || '/collections/all';

    // path[0] is always the Shop parent — already rendered as "Shop All" in Liquid
    var pathToShow = savedBreadcrumb.path.slice(1).filter(function (crumb) {
      return !isShopAllCrumb(crumb, shopAllUrl);
    });

    // Sin ruta útil (ej. vino de Shop All): no pisar el breadcrumb de Liquid
    if (pathToShow.length === 0) {
      return;
    }

    breadcrumbsList.innerHTML = '';

    var shopAllLi = document.createElement('li');
    shopAllLi.className = 'breadcrumbs__item';
    var shopAllAnchor = document.createElement('a');
    shopAllAnchor.href = shopAllUrl;
    shopAllAnchor.className = 'breadcrumbs__link';
    shopAllAnchor.textContent = 'Shop All';
    shopAllLi.appendChild(shopAllAnchor);
    breadcrumbsList.appendChild(shopAllLi);

    pathToShow.forEach(function (crumb) {
      var li = document.createElement('li');
      li.className = 'breadcrumbs__item';

      var separator = document.createElement('span');
      separator.className = 'breadcrumbs__separator';
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = '/';

      var link = document.createElement('a');
      link.href = crumb.url;

      var isCurrent = isLastItemCurrentPage && crumb === lastPathItem;
      link.className = isCurrent
        ? 'breadcrumbs__link breadcrumbs__link--current'
        : 'breadcrumbs__link';
      link.textContent = capitalizeTitle(crumb.title);

      if (isCurrent) {
        link.setAttribute('aria-current', 'page');
      }

      li.appendChild(separator);
      li.appendChild(link);
      breadcrumbsList.appendChild(li);
    });

    if (!isLastItemCurrentPage) {
      var productLi = document.createElement('li');
      productLi.className = 'breadcrumbs__item';

      var productSeparator = document.createElement('span');
      productSeparator.className = 'breadcrumbs__separator';
      productSeparator.setAttribute('aria-hidden', 'true');
      productSeparator.textContent = '/';

      var productLink = document.createElement('a');
      productLink.href = productInfo.url;
      productLink.className = 'breadcrumbs__link breadcrumbs__link--current';
      productLink.setAttribute('aria-current', 'page');
      productLink.textContent = productInfo.title;

      productLi.appendChild(productSeparator);
      productLi.appendChild(productLink);
      breadcrumbsList.appendChild(productLi);
    }

    breadcrumbsNav.dataset.breadcrumbsSource = 'sessionStorage';
  }

  function init() {
    enhanceBreadcrumbs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 120);
    });
  } else {
    setTimeout(init, 120);
  }
})();
